// ----------------------------------- Actions ---------------------------------

import { type UnknownAction } from '@reduxjs/toolkit';

// Action Types
const SELECT_TAB = 'widgets/select_tab';
const SET_EDIT_MODE = 'widgets/set_edit_mode';

// Action Creators
export const selectTab = (tabIndex: number) => ({ type: SELECT_TAB, payload: tabIndex });
export const setEditMode = (editMode: boolean) => ({
  type: SET_EDIT_MODE,
  payload: editMode,
});

interface WidgetState {
  selectedTab: number;
  editMode: boolean;
}

// ----------------------------------- Reducer ---------------------------------
// Init State
const INIT_STATE: WidgetState = {
  selectedTab: 0,
  editMode: false,
};

// Reducer
const widgetReducer = (state = INIT_STATE, action: UnknownAction): WidgetState => {
  const { type, payload } = action;
  switch (type) {
    case SELECT_TAB: {
      return { ...state, selectedTab: payload as number };
    }
    case SET_EDIT_MODE: {
      return { ...state, editMode: payload as boolean };
    }
    default: {
      return state;
    }
  }
};

export default widgetReducer;
